// @flow

import Mustache from "mustache";
import { getUserData } from "../user-data";

import type { UserData } from "../user-data/user-data-type";

const MAP_TEMPLATE_ID_TO_ORIGIN_TEMPLATE: {
    [key: string]: string
} = {};

function queryAll(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
}

export function render({
    mustacheDoms = queryAll("[data-reece-mustache-template-id]"),
    targetDoms = queryAll("[data-reece-mustache-template-id]")
}: {
    mustacheDoms: HTMLElement[],
    targetDoms: HTMLElement[],
    delay: number
} = {}) {
    const userDataPromise: Promise<?UserData> = getUserData();
    userDataPromise.then(userData => {
        if (userData) {
            ((document.body: any): HTMLElement).classList.add(
                userData.isMaxUser === true ? "trade-user" : "homeowner-user"
            );
        }
        mustacheDoms.forEach((dom, idx) => {
            renderTemplate(dom, targetDoms[idx], userData);
        });
    });
}

function renderTemplate(
    templateDom: HTMLElement,
    target: HTMLElement,
    userData: ?UserData
) {
    const templateId = templateDom.dataset.reeceMustacheTemplateId;
    let originTemplate = MAP_TEMPLATE_ID_TO_ORIGIN_TEMPLATE[templateId];
    if (!originTemplate) {
        originTemplate = templateDom.innerHTML;
        MAP_TEMPLATE_ID_TO_ORIGIN_TEMPLATE[templateId] = originTemplate;
    }
    const html = Mustache.render(originTemplate, userData);
    target.innerHTML = html;
    evalScriptsInsideTarget(target);
}

function evalScriptsInsideTarget(target) {
    const arRawScripts = queryAll('[data-template-script-re-eval="true"]');
    arRawScripts.forEach(rawScript => {
        const rawSrc = rawScript.getAttribute("src");
        const rawAsync = rawScript.getAttribute("async");
        const rawDefer = rawScript.getAttribute("defer");
        const rawTextContent = rawScript.textContent;

        const newEleScript = document.createElement("script");
        newEleScript.setAttribute('type', 'text/javascript');
        if (rawSrc) newEleScript.setAttribute("src", rawSrc);
        if (rawAsync) newEleScript.setAttribute("async", rawAsync);
        if (rawDefer) newEleScript.setAttribute("defer", rawDefer);
        if (rawTextContent) {
            const newTextNode = document.createTextNode(rawTextContent);
            newEleScript.appendChild(newTextNode);
        }

        document.body.appendChild(newEleScript);
    });
}
